import cx from 'classnames';
import {
    ASK_AN_EXPERT,
    BAZAAR,
    BLOGS_MENU_FEEDS,
    BLOGS_WALL,
    BZ2_ADD_PRODUCT,
    BZ2_FAQ,
    BZ2_WISHLIST,
    FORUM,
    FORUMS_AND_GROUPS,
    GROUP_LIST,
    HEADING_SELLERS,
    LOG_IN,
    MY_ENTRIES,
    MY_SHOPPING,
    PB_MENU_FIND_MOM,
    PB_MENU_MY_ACTIVITY,
    PHOTOBLOGS,
    REGISTER_HERE,
    SERVER_FULL_NAME,
    SERVER_SLOGAN,
} from 'mk/autogenerated/translations/DesktopHeader.2dedc027372164883db2b400851719f7'
import { WIKI_CATEGORIES } from 'mk/autogenerated/wikiCategories';
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import {
    about_help_url,
    bazaar_single_page_create_product_url,
    bazaar_single_page_my_bazaar_url,
    bazaar_single_page_product_grid_url,
    bazaar_single_page_seller_search_url,
    bazaar_single_page_shopping_url,
    bazaar_single_page_wishlist_url,
    group_list_url,
    photoblog_index_category_url,
    photoblog_index_url,
    user_directory_url,
} from 'mk/urls/functions';
import { counsellingsHomeUrl } from 'mk2/apps/counsellings/urls';
import { forumFeedNewestUrl, forumUrl } from 'mk2/apps/forum/urls';
import { homepageUrl } from 'mk2/apps/home/urls';
import { loginUrl, signupUrl } from 'mk2/apps/users/urls';
import { wikiCategoryUrl } from 'mk2/apps/wiki/utils';
import Img from 'mk2/components/Img';
import Interpolate from 'mk2/components/Interpolate';
import NotificationMenu from 'mk2/components/NotificationMenu';
import NotificationsBadge, { Count, Type } from 'mk2/components/NotificationsBadge';
import { MenuItem } from 'mk2/containers/PageHeader/PageHeader.reducers';
import styles from 'mk2/containers/SiteMenu/DesktopHeader.mscss';
import { CompatibleLink } from 'mk2/containers/SiteMenu/SiteMenu';
import { modrykonikLogoUrl, url } from 'mk2/helpers/urls';
import { HeaderMenuItem, MenuSelection, SubscribedCounsellingsCounts, UserEntity } from 'mk2/schemas';
import { parse, stringify } from 'query-string';
import React from 'react';

interface OwnProps {
    menuSelection?: MenuSelection;
    fluxibleCompatibility: boolean;
    currentUrl: string;  // nemozeme pouzit withRouter(), ten nefunguje v bazari

    requestUser: UserEntity;
    requestUserPermissions: string[];
    isMobile: boolean;
    heartsCount: number;
    unreadMails: number;
    newBazaarEvents: number;
    newBazaarSell: number;
    allBazaarSell: number;
    wallStatusNews: number;
    wishlistUpdates: number;
    groupsCount: number;
    subscribedCounsellings: SubscribedCounsellingsCounts;
    disableSectionTabs?: boolean;
    disableNotificationMenu?: boolean;
    disableLogoLink?: boolean;
    feedMenu: MenuItem[];
    mergedForumAndGroups?: boolean;

    /** Right content, after notification menu - e.g. primary action button */
    right?: React.ReactNode;

    notificationMenuRef: React.RefObject<NotificationMenu>;
    onMenuClose();
}

interface SectionTabItem {
    section: string;
    content: React.ReactNode;
}

interface SubMenuItem {
    menuItem: string;
    className?: string;
    content: React.ReactNode;
}

type Props = OwnProps;

export class DesktopHeader extends React.PureComponent<Props> {

    public render() {
        const { menuSelection, disableSectionTabs, disableNotificationMenu, mergedForumAndGroups, right } = this.props;

        let activeSection;
        let activeItem;
        if (menuSelection && menuSelection.activeSection) {
            activeSection = menuSelection.activeSection;
            if (mergedForumAndGroups && (activeSection === 'forum' || activeSection === 'groups')) {
                activeSection = 'forum_and_groups';
            }
        }
        if (menuSelection && menuSelection.activeItem) {
            activeItem = menuSelection.activeItem;
        }

        return (
            <div className={styles.DesktopHeader}>
                <div className={styles.DesktopHeader__mainWrapper}>
                    <div className={styles.DesktopHeader__main}>
                        {this.renderLogo(activeSection, activeItem)}

                        {/* Bazar, Forum, Stena, Poradne */}
                        {!disableSectionTabs && this.renderSectionTabs(activeSection, activeItem)}

                        {/* Hearts, IP, Wall, Settings */}
                        {!disableNotificationMenu && this.renderHeartsWallSettingsStripe(activeSection, activeItem)}

                        {right}
                    </div>
                </div>

                {['photoblog', 'bazaar', 'home', 'wiki'].indexOf(activeSection) >= 0 && (
                    <div className={styles.DesktopHeader__subMenuWrapper}>
                        {activeSection === 'photoblog'
                            ? this.renderBlogsSubMenu(activeItem)
                            : activeSection === 'bazaar'
                                ? this.renderMarketSubMenu(activeItem)
                                : (activeSection === 'home' || activeSection === 'wiki')
                                    ? this.renderHomeSubMenu(activeItem)
                                    : null
                        }
                    </div>
                )}
            </div>
        );
    }

    private renderLogo(activeSection: string, activeItem: string) {
        const { onMenuClose, fluxibleCompatibility, disableLogoLink } = this.props;

        const logo = (
            <Img
                lazy={false}
                height={34}
                width={150}
                alt={SERVER_FULL_NAME + ' - ' + SERVER_SLOGAN}
                src={modrykonikLogoUrl()}
            />
        );

        return (
            <div
                onClick={onMenuClose}
                className={cx(
                    styles.DesktopHeader__logo,
                    (activeSection === 'home' || activeSection === 'wiki') && styles['DesktopHeader__tabItem--active'],
                )}
            >
                {!disableLogoLink
                    ? (
                        <CompatibleLink
                            fluxibleCompatibility={fluxibleCompatibility}
                            title={SERVER_FULL_NAME + ' - ' + SERVER_SLOGAN}
                            to={homepageUrl}
                        >
                            {logo}
                        </CompatibleLink>
                    ) : (
                        logo
                    )
                }
            </div>
        );
    }

    private renderSectionTabs(activeSection: string, activeItem: string) {
        const {
            fluxibleCompatibility, newBazaarEvents, newBazaarSell, subscribedCounsellings, onMenuClose, mergedForumAndGroups,
        } = this.props;

        const totalSubscribedCounsellings = Object.keys(subscribedCounsellings || {}).reduce((acc, cur) => acc + subscribedCounsellings[cur], 0);

        const items: SectionTabItem[] = [
            {
                section: 'bazaar',
                content: (
                    <a
                        className={styles.DesktopHeader__tabItemLink}
                        href={bazaar_single_page_product_grid_url()}
                    >
                        {BAZAAR}
                        <NotificationsBadge
                            className={styles.DesktopHeader__tabItemNotificationsBadge}
                            count={newBazaarEvents + newBazaarSell}
                            type={Type.Important}
                        />
                    </a>
                ),
            }, {
                section: mergedForumAndGroups ? 'forum_and_groups' : 'forum',
                content: (
                    <CompatibleLink
                        fluxibleCompatibility={fluxibleCompatibility}
                        className={styles.DesktopHeader__tabItemLink}
                        to={mergedForumAndGroups ? forumFeedNewestUrl : forumUrl}
                    >
                        {mergedForumAndGroups ? FORUMS_AND_GROUPS : FORUM}
                    </CompatibleLink>
                ),
            }, {
                section: 'photoblog',
                content: (
                    <a
                        className={styles.DesktopHeader__tabItemLink}
                        href={photoblog_index_url()}
                    >
                        {mergedForumAndGroups ? BLOGS_WALL : PHOTOBLOGS}
                    </a>
                ),
            }, {
                section: 'counsellings',
                content: (
                    <CompatibleLink
                        fluxibleCompatibility={fluxibleCompatibility}
                        className={styles.DesktopHeader__tabItemLink}
                        to={counsellingsHomeUrl}
                    >
                        {ASK_AN_EXPERT}
                        <NotificationsBadge
                            className={styles.DesktopHeader__tabItemNotificationsBadge}
                            count={totalSubscribedCounsellings}
                        />
                    </CompatibleLink>
                ),
            },
        ];

        return (
            <ul className={styles.DesktopHeader__tabs}>
                {items.map((item) => (
                    <li
                        key={item.section}
                        onClick={onMenuClose}
                        className={cx(
                            styles.DesktopHeader__tabItem,
                            activeSection === item.section && styles['DesktopHeader__tabItem--active'],
                        )}
                    >
                        {item.content}
                    </li>
                ))}
            </ul>
        );
    }

    private renderHomeSubMenu(activeItem: string) {
        const { fluxibleCompatibility } = this.props;

        const items: SubMenuItem[] = WIKI_CATEGORIES
            .filter((wikiCategory) => wikiCategory.id !== 11)
            .map((wikiCategory, i) => ({
                menuItem: wikiCategory.slug,
                content: (
                    <CompatibleLink
                        fluxibleCompatibility={fluxibleCompatibility}
                        className={cx(
                            styles.DesktopHeader__subMenuItemLink,
                            i === 0 && styles['DesktopHeader__subMenuItemLink--first'],
                        )}
                        to={wikiCategoryUrl(wikiCategory)}
                    >
                        {wikiCategory.name}
                    </CompatibleLink>
                ),
            }));

        return this.renderGenericSubMenu(items, activeItem);
    }

    private renderBlogsSubMenu(activeItem: string) {
        const { feedMenu, groupsCount, requestUser, requestUserPermissions } = this.props;

        const isBlogsAdmin = requestUserPermissions.indexOf('photoblog.can_manage_blogs') >= 0;
        const feedsCount = feedMenu !== null && feedMenu.length > 0 && feedMenu.filter((item) => item.name === 'feeds').reduce((acc: Count, val) => val.lastVisitCount, null);

        const items: SubMenuItem[] = isAuthenticated(requestUser)
            ? [
                {
                    menuItem: 'group-list',
                    content: (
                        <a
                            className={cx(
                                styles.DesktopHeader__subMenuItemLink,
                                styles['DesktopHeader__subMenuItemLink--first'],
                            )}
                            href={group_list_url()}
                        >
                            {GROUP_LIST}
                            {groupsCount > 0 && (<i>{groupsCount}</i>)}
                        </a>
                    ),
                }, {
                    menuItem: 'feeds',
                    content: (
                        <a
                            className={styles.DesktopHeader__subMenuItemLink}
                            href={photoblog_index_url()}
                        >
                            {BLOGS_MENU_FEEDS}
                            {feedsCount && (<i>{feedsCount}</i>)}
                        </a>
                    ),
                }, {
                    menuItem: 'my-activity',
                    content: (
                        <a
                            className={styles.DesktopHeader__subMenuItemLink}
                            href={photoblog_index_category_url('my-activity')}
                        >
                            {PB_MENU_MY_ACTIVITY}
                        </a>
                    ),
                }, {
                    menuItem: 'user-directory',
                    content: (
                        <a
                            className={styles.DesktopHeader__subMenuItemLink}
                            href={user_directory_url()}
                        >
                            {PB_MENU_FIND_MOM}
                        </a>
                    ),
                },
            ] : [
                {
                    menuItem: 'group-list',
                    content: (
                        <a
                            className={cx(
                                styles.DesktopHeader__subMenuItemLink,
                                styles['DesktopHeader__subMenuItemLink--first'],
                            )}
                            href={group_list_url()}
                        >
                            {GROUP_LIST} {groupsCount > 0 && (<i>{groupsCount}</i>)}
                        </a>
                    ),
                },
            ];

        if (isBlogsAdmin) {
            const flaggedCount = feedMenu !== null && feedMenu.length > 0 && feedMenu.filter((item) => item.name === 'flagged').reduce((acc: Count, val) => val.lastVisitCount, null);
            items.push({
                menuItem: 'flagged',
                content: (
                    <a
                        className={styles.DesktopHeader__subMenuItemLink}
                        href={photoblog_index_category_url('flagged')}
                    >
                        Flagged
                        {flaggedCount && (<i>{flaggedCount}</i>)}
                    </a>
                ),
            });
        }

        return this.renderGenericSubMenu(items, activeItem);
    }

    private renderMarketSubMenu(activeItem: string) {
        const { requestUser, newBazaarSell, allBazaarSell, wishlistUpdates, newBazaarEvents } = this.props;

        const items: SubMenuItem[] = isAuthenticated(requestUser)
            ? [
                {
                    menuItem: HeaderMenuItem.BazaarMyBazaar,
                    content: (
                        <a
                            className={cx(
                                styles.DesktopHeader__subMenuItemLink,
                                styles['DesktopHeader__subMenuItemLink--first'],
                            )}
                            href={bazaar_single_page_my_bazaar_url(requestUser.username)}
                        >
                            {MY_ENTRIES}
                            {newBazaarSell > 0 ? (
                                <NotificationsBadge className={styles.DesktopHeader__tabItemNotificationsBadge} count={newBazaarSell} type={Type.Important} />
                            ) : allBazaarSell > 0 ? (
                                <i>{allBazaarSell}</i>
                            ) : null}
                        </a>
                    ),
                }, {
                    menuItem: HeaderMenuItem.BazaarWishlist,
                    content: (
                        <a
                            className={styles.DesktopHeader__subMenuItemLink}
                            href={bazaar_single_page_wishlist_url(requestUser.username)}
                        >
                            {BZ2_WISHLIST}
                            {wishlistUpdates > 0 && (<i>{wishlistUpdates}</i>)}
                        </a>
                    ),
                }, {
                    menuItem: HeaderMenuItem.BazaarShopping,
                    content: (
                        <a
                            className={styles.DesktopHeader__subMenuItemLink}
                            href={bazaar_single_page_shopping_url(requestUser.username)}
                        >
                            {MY_SHOPPING}
                            <NotificationsBadge
                                className={styles.DesktopHeader__tabItemNotificationsBadge}
                                count={newBazaarEvents}
                                type={Type.Important}
                            />
                        </a>
                    ),
                }, {
                    menuItem: HeaderMenuItem.BazaarSellerSearch,
                    content: (
                        <a
                            className={styles.DesktopHeader__subMenuItemLink}
                            href={bazaar_single_page_seller_search_url()}
                        >
                            {HEADING_SELLERS}
                        </a>
                    ),
                }, {
                    menuItem: HeaderMenuItem.BazaarFaq,
                    content: (
                        <a
                            className={styles.DesktopHeader__subMenuItemLink}
                            href={about_help_url() + '#cat-howto-market'}
                        >
                            {BZ2_FAQ}
                        </a>
                    ),
                }, {
                    menuItem: HeaderMenuItem.BazaarAddItem,
                    className: styles['DesktopHeader__subMenuItem--right'],
                    content: (
                        <a
                            className={cx(
                                styles.DesktopHeader__subMenuItemLink,
                                styles['DesktopHeader__subMenuItemLink--add'],
                            )}
                            href={bazaar_single_page_create_product_url()}
                        >
                            <span className={cx(styles.DesktopHeader__subMenuItemLinkAddIcon, 'fa', 'fa-plus-circle')} />
                            {BZ2_ADD_PRODUCT}
                        </a>
                    ),
                },
            ] : [
                {
                    menuItem: HeaderMenuItem.BazaarFaq,
                    content: (
                        <a
                            className={styles.DesktopHeader__subMenuItemLink}
                            href={about_help_url() + '#cat-howto-market'}
                        >
                            {BZ2_FAQ}
                        </a>
                    ),
                }, {
                    menuItem: HeaderMenuItem.BazaarAddItem,
                    className: styles['DesktopHeader__subMenuItem--right'],
                    content: (
                        <a
                            className={cx(
                                styles.DesktopHeader__subMenuItemLink,
                                styles['DesktopHeader__subMenuItemLink--add'],
                            )}
                            href={bazaar_single_page_create_product_url()}
                        >
                            <span className={cx(styles.DesktopHeader__subMenuItemLinkAddIcon, 'fa', 'fa-plus-circle')} />
                            {BZ2_ADD_PRODUCT}
                        </a>
                    ),
                },
            ];

        return this.renderGenericSubMenu(items, activeItem);
    }

    private renderGenericSubMenu(items: SubMenuItem[], activeItem: string) {
        return (
            <ul className={styles.DesktopHeader__subMenu}>
                {items.map((item) => (
                    <li
                        key={item.menuItem}
                        className={cx(
                            styles.DesktopHeader__subMenuItem,
                            item.className,
                            activeItem === item.menuItem && styles['DesktopHeader__subMenuItem--active'],
                            activeItem === item.menuItem && 'topmenu-activeLink',
                        )}
                    >
                        {item.content}
                    </li>
                ))}
            </ul>
        );
    }

    private renderHeartsWallSettingsStripe(activeSection: string, activeItem: string) {
        const {
            heartsCount, unreadMails, wallStatusNews, requestUser, fluxibleCompatibility, onMenuClose,
            notificationMenuRef,
        } = this.props;

        return (requestUser && isAuthenticated(requestUser)) ? (
            <NotificationMenu
                ref={notificationMenuRef}
                heartsCount={heartsCount}
                unreadMails={unreadMails}
                wallStatusNews={wallStatusNews}
                fluxibleCompatibility={fluxibleCompatibility}
                requestUser={requestUser}
                activeSection={activeSection}
                activeItem={activeItem}
                onItemClick={onMenuClose}
                relocateWithNextParam={this.relocateWithNextParam}
            />
        ) : (
            <div className={styles.DesktopHeader__user}>
                <CompatibleLink
                    fluxibleCompatibility={fluxibleCompatibility}
                    className={styles['DesktopHeader__user--loginLink']}
                    to={this.relocateWithNextParam(loginUrl)}
                    rel="nofollow"
                >
                    <Interpolate i18nKey={LOG_IN} />
                </CompatibleLink>
                <CompatibleLink
                    fluxibleCompatibility={fluxibleCompatibility}
                    className={cx(styles['DesktopHeader__user--registerLink'], 'topmenu-registerLink')}
                    to={this.relocateWithNextParam(url(signupUrl, {}, { mkutm_campaign: 'menu_registration', mkutm_source: 'modrykonik' }))}
                    rel="nofollow"
                >
                    {REGISTER_HERE}
                </CompatibleLink>
            </div>
        );
    }

    private relocateWithNextParam = (thisHref) => {
        const { currentUrl } = this.props;

        if (!currentUrl) {
            return thisHref;
        }

        // remove ?qs from urls
        const currentPath = currentUrl.indexOf('?') > 0 ? currentUrl.substr(0, currentUrl.indexOf('?')) : currentUrl;
        const hrefPath = thisHref.indexOf('?') > 0 ? thisHref.substr(0, thisHref.indexOf('?')) : thisHref;

        if (currentPath === hrefPath) {
            return thisHref;
        } else {
            const hrefQS = thisHref.substring(hrefPath.length + 1);
            const qs = parse(hrefQS);
            qs.next = currentUrl;
            return `${hrefPath}?${stringify(qs)}`;
        }
    };
}
